<template>
  <div id="mobile-login-wrap" class="mobile-login">
    <h2>Login (Mobile)</h2>

    <form @submit.prevent="onSubmit" class="login-form">
      <label class="sr-only" for="username">Username</label>
      <input id="username" type="text" v-model="input.username" placeholder="Username" required />

      <label class="sr-only" for="password">Password</label>
      <input id="password" type="password" v-model="input.password" placeholder="Password" />

      <button type="submit" class="submit">Login</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MobileLogin',
  data() {
    return {
      input: { username: '', password: '' },
    };
  },
  methods: {
    onSubmit() {
      const user = { username: this.input.username, password: this.input.password };

      const loader = this.$loading?.show
        ? this.$loading.show({ height: 48, width: 48, color: '#00ab00', isFullPage: true })
        : null;

      // reuse the same auth store action as desktop Login
      this.$store.dispatch('auth/login', user).then(
        () => {
          this.$router.push('/mobile');
          loader?.hide();
        },
        () => {
          loader?.hide();
          alert('Login failed: Please check username or password');
        }
      );
    },
  },
};
</script>

<style scoped>
.mobile-login { padding: 14px; font-family: Arial, Helvetica, sans-serif }
.mobile-login h2 { font-size: 18px; margin-bottom: 12px }
.login-form { display:flex; flex-direction:column; gap:10px }
input[type='text'], input[type='password'] { padding:12px; font-size:16px; border:1px solid #d9d9d9; border-radius:6px }
.submit { padding:12px; background:#04aa6d; color:#fff; border:none; font-weight:600; border-radius:6px }
.sr-only { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0 0 0 0); white-space:nowrap; border:0 }
</style>